import type en from "~/locales/en.json";

export type SplitOnDot<T extends string> =
  T extends `${infer Head}.${infer Tail}`
    ? Head | `${Head}.${SplitOnDot<Tail>}`
    : T;

export type JsonToDotPath<T> =
  T extends Record<string, any>
    ? {
        [K in keyof T]: T[K] extends Record<string, any>
          ? `${K & string}.${JsonToDotPath<T[K]>}`
          : K & string;
      }[keyof T]
    : never;

export type FilterByPath<
  T extends Record<string, any>,
  Path extends string,
> = Path extends `${infer Head}.${infer Tail}`
  ? Head extends keyof T
    ? T[Head] extends Record<string, any>
      ? FilterByPath<T[Head], Tail>
      : never
    : never
  : T[Path];

export function useI18nKey<T extends SplitOnDot<JsonToDotPath<typeof en>>>(
  keyPathStart: T,
) {
  return <V extends JsonToDotPath<FilterByPath<typeof en, T>>>(
    keyPathEnd: V,
  ): `${T}.${V}` => `${keyPathStart}.${keyPathEnd}`;
}
